export const Home = () => {
  return (
    <section className="container">
      <h1>Welcome to Contacts Site</h1>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto,
        laboriosam placeat incidunt rem illum animi nemo quibusdam quia
        voluptatum voluptate.
      </p>
    </section>
  );
};
